'use script';

angular.module('classe_a.controllers')
	.controller('AboutCtrl', [function() {
		
		

	}]);